export const serviceConstant={
    storageType:"mock"
}